/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from 'react';
import { LinkContainer } from 'react-router-bootstrap';

// Styled Components Import
import styled from 'styled-components';

// Animation on Scroll
import Zoom from 'react-reveal/Zoom';

// Bootstrap Imports
import Button from 'react-bootstrap/Button';
import Col from 'react-bootstrap/Col';
import Container from 'react-bootstrap/Container';
import Image from 'react-bootstrap/Image';
import Row from 'react-bootstrap/Row';
import Spinner from 'react-bootstrap/Spinner';

// Fontawessome Imports
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
	faFacebookF,
	faInstagram,
	faTiktok,
	faWhatsapp,
} from '@fortawesome/free-brands-svg-icons';

// Firebase Imports
import { storage } from '../../../config/fbConfig';

// Local Imports
import RegisterLeadsForm from './RegisterLeadsForm';

// Styled Components
const HeroSection = styled.div`
	background: url('${(props) => props.descktopImageUrl}') no-repeat;
	background-size: cover;
	height: 550px;
	border-radius: 0px !important;

	@media (max-width: 768px) {
		background: url('${(props) => props.mobileImageUrl}') no-repeat;
		background-size: cover;
	}
`;

const Welcome = () => {
	// Component State
	const [descktopImageUrl, setDescktopImageUrl] = useState('');
	const [mobileImageUrl, setMobileImageUrl] = useState('');
	const [mobileProfileImageUrl, setMobileProfileImageUrl] = useState('');
	const [profileImageReady, setProfileImageReady] = useState(false);

	// Modal Form State
	const [showModal, setShowModal] = useState(false);

	// Component Hooks
	useEffect(() => {
		storage
			.ref('static-web-imgs')
			.child('hero-background-desktop-perfil_1440x810.jpg')
			.getDownloadURL()
			.then((res) => {
				setDescktopImageUrl(res);
			});

		storage
			.ref('static-web-imgs')
			.child('hero-background-mobile_300x311.jpg')
			.getDownloadURL()
			.then((res) => {
				setMobileImageUrl(res);
			});

		storage
			.ref('static-web-imgs')
			.child('majo-perfil-mobile_300x311.png')
			.getDownloadURL()
			.then((res) => {
				setMobileProfileImageUrl(res);
				setProfileImageReady(true);
			});
	}, []);

	return (
		<>
			<div className='body-container'>
				<HeroSection
					className='mb-3 custom-vertical-align'
					descktopImageUrl={descktopImageUrl}
					mobileImageUrl={mobileImageUrl}>
					<Container style={{ position: 'relative' }}>
						<Row className='custom-vertical-align'>
							<Col xs={0} md={6} />
							<Col
								xs={12}
								md={6}
								className='text-center mb-0 mb-md-5 pb-0 pb-md-4'>
								<Zoom>
									<div>
										<div
											className='mb-4 ml-5'
											style={{ fontSize: '1.2rem', textAlign: 'initial' }}>
											<span
												className='hero-secondary-text'
												style={{
													color: '#a8f0e3',
													textTransform: 'uppercase',
												}}>
												Hola,
											</span>{' '}
											<span
												className='hero-secondary-text'
												style={{ color: '#fff', textTransform: 'uppercase' }}>
												soy
											</span>
										</div>
									</div>
								</Zoom>
								<div className='d-flex align-items-center'>
									{!profileImageReady ? (
										<div
											className='spinner-container d-flex align-items-center justify-content-center mx-2'
											style={{ minWidth: 108, maxWidth: '30vw' }}>
											<Spinner
												animation='grow'
												className='mx-auto'
												style={{
													color: '#540963',
												}}
											/>
										</div>
									) : (
										<Zoom>
											<div>
												<div
													className='spinner-container d-flex align-items-center justify-content-center mx-2'
													style={{ minWidth: 108, maxWidth: '30vw' }}>
													<Image
														className='majo-mobile-img'
														src={mobileProfileImageUrl}
														alt='Majo Cobos'
													/>
												</div>
											</div>
										</Zoom>
									)}
									<Zoom>
										<div>
											<h1>
												<span className='majo-font' style={{ color: '#fff' }}>
													Majo Cobos
												</span>
											</h1>
										</div>
									</Zoom>
								</div>
								<Zoom>
									<div>
										<div className='d-flex align-items-center justify-content-center mt-4 mb-5 mx-5'>
											<div
												className='mr-3'
												style={{
													height: 1,
													backgroundColor: '#fff',
													width: 40,
												}}
											/>
											<h5
												className='hero-secondary-text'
												style={{
													color: '#fff',
													fontSize: '1.2rem',
													textTransform: 'uppercase',
													marginBottom: 0,
												}}>
												MKT & Sales Consultant
											</h5>
										</div>
									</div>
								</Zoom>
								<div className='d-md-flex mt-5 mt-md-4'>
									<Zoom>
										<div
											className='mb-md-0 mb-3 mr-sm-0 mr-md-3'
											style={{ fontWeight: 500, minWidth: 190 }}>
											<Button
												variant=''
												size='lg'
												className='cta-hero-btn btn-rounded px-4'
												onClick={() => setShowModal(true)}>
												Contáctame
											</Button>
										</div>
									</Zoom>
									<Zoom>
										<div>
											<LinkContainer to={'/signup/'}>
												<Button
													variant=''
													size='lg'
													className='cta-hero-secondary-btn btn-rounded shadow-sm px-4'
													style={{ fontWeight: 500, minWidth: 190 }}>
													Visita mi CV
												</Button>
											</LinkContainer>
										</div>
									</Zoom>
								</div>
							</Col>
						</Row>
						<div className='side-social-btns d-flex align-items-center justify-content-center mt-4 mt-md-0'>
							<Button
								className='social-hero-btn d-flex align-items-center justify-content-center mb-0 mb-md-3 mr-3 mr-md-0'
								style={{ borderRadius: 50, height: 40, width: 40 }}
								href='https://api.whatsapp.com/send?phone=593995018419&text=Hola%20Majo,%20me%20gustar%C3%ADa%20conocer%20sobre%20tu%20servicio%20de%20asesor%C3%ADa'
								target='_blank'>
								<FontAwesomeIcon
									icon={faWhatsapp}
									style={{ fontSize: '1.3rem' }}
								/>
							</Button>
							<Button
								className='social-hero-btn d-flex align-items-center justify-content-center mb-0 mb-md-3 mr-3 mr-md-0'
								style={{ borderRadius: 50, height: 40, width: 40 }}
								href='#'
								target='_blank'>
								<FontAwesomeIcon
									icon={faFacebookF}
									style={{ fontSize: '1.3rem' }}
								/>
							</Button>
							<Button
								className='social-hero-btn d-flex align-items-center justify-content-center mb-0 mb-md-3 mr-3 mr-md-0'
								style={{ borderRadius: 50, height: 40, width: 40 }}
								href='https://instagram.com/majocobosc?igshid=3e6i9gf2opd6'
								target='_blank'>
								<FontAwesomeIcon
									icon={faInstagram}
									style={{ fontSize: '1.3rem' }}
								/>
							</Button>
							<Button
								className='social-hero-btn d-flex align-items-center justify-content-center mb-0 mr-md-0'
								style={{ borderRadius: 50, height: 40, width: 40 }}
								href='https://vm.tiktok.com/ZMJpKCqAB/'
								target='_blank'>
								<FontAwesomeIcon
									icon={faTiktok}
									style={{ fontSize: '1.3rem' }}
								/>
							</Button>
						</div>
					</Container>
				</HeroSection>
				<RegisterLeadsForm
					show={showModal}
					onHide={() => setShowModal(false)}
				/>
			</div>
		</>
	);
};

export default Welcome;
